import { render, staticRenderFns } from "./BTableV1.vue?vue&type=template&id=6ba54c05&"
import script from "./BTableV1.vue?vue&type=script&lang=js&"
export * from "./BTableV1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports